import { render, staticRenderFns } from "./PixArea.vue?vue&type=template&id=fa8dc1e8&scoped=true"
import script from "./PixArea.vue?vue&type=script&lang=js"
export * from "./PixArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8dc1e8",
  null
  
)

export default component.exports